export default {
 pageTitle: '法务服务',
 heroDesc: '专业法律服务，为您的跨境业务保驾护航',
 featuresTitle: '服务特色',
 featuresSubtitle: '专业、严谨、全球化的法律服务',
 feature1Title: '专业律师',
 feature1Desc: '全球顶尖律师团队',
 feature2Title: '经验丰富',
 feature2Desc: '20+年跨境法律服务经验',
 feature3Title: '全球覆盖',
 feature3Desc: '服务网络遍布50+国家',
 feature4Title: '一站式服务',
 feature4Desc: '全方位法律解决方案',
 viewDetails: '查看详情',
 service1Title: '法律查明及法律意见书',
 service1Subtitle: '境外法律问题专业解答',
 service1Desc: '企业在境外运作过程中会面临多种多样的境外法律问题，LEVIY依托遍布全球的法律服务网络，可为当事人或国内律师事务所进行相关国家和地区的法律查明，并就由此而涉及的相关法律适用问题及客户关注的其他问题出具法律意见书。',
 service1Feature1Title: '法律查明服务',
 service1Feature1Item1: '境外法律法规查明',
 service1Feature1Item2: '法律适用性分析',
 service1Feature1Item3: '相关国家和地区法律研究',
 service1Feature1Item4: '为国内律师事务所提供支持',
 service1Feature1Item5: '多司法管辖区法律对比',
 service1Feature2Title: '法律意见书',
 service1Feature2Item1: '专业法律意见书出具',
 service1Feature2Item2: '法律风险评估',
 service1Feature2Item3: '合规性建议',
 service1Feature2Item4: '法律解决方案',
 service2Title: '境外公证和认证',
 service2Subtitle: '全球公证认证服务',
 service2Desc: '应中国司法、行政机关或当事人要求，LEVIY可就境外相关证据或文件在境外办理政府、律师、公证机关以及中国驻外使领馆公证和认证。',
 service2Feature1Title: '公证服务',
 service2Feature1Item1: '政府公证服务',
 service2Feature1Item2: '律师公证服务',
 service2Feature1Item3: '公证机关公证',
 service2Feature1Item4: '各类证据和文件公证',
 service2Feature1Item5: '商业文件公证',
 service2Feature2Title: '认证服务',
 service2Feature2Item1: '中国驻外使领馆认证',
 service2Feature2Item2: '领事认证服务',
 service2Feature2Item3: '海牙认证',
 service2Feature2Item4: '文件翻译认证',
 service3Title: '尽职调查',
 service3Subtitle: '全面专业的尽职调查',
 service3Desc: '针对涉及投资、贸易和服务的合作方、伙伴、交易对方以及目的国（地区）的法律政策及相关方面的全面尽职调查，LEVIY可以赴公司实际经营地进行考察，调查了解其经营背景和现实状况、财务和资信状况、雇员和场地实地查证等，也可以根据客户要求量身定制，保证调查结果权威和准确。',
 service3Feature1Title: '实地考察调查',
 service3Feature1Item1: '赴公司实际经营地考察',
 service3Feature1Item2: '经营背景和现实状况调查',
 service3Feature1Item3: '财务和资信状况核查',
 service3Feature1Item4: '雇员和场地实地查证',
 service3Feature1Item5: '业务运营情况评估',
 service3Feature2Title: '法律政策调查',
 service3Feature2Item1: '目的国（地区）法律政策研究',
 service3Feature2Item2: '合作方、伙伴背景调查',
 service3Feature2Item3: '交易对方资质核查',
 service3Feature2Item4: '量身定制调查方案',
 service3Feature2Item5: '权威准确的调查报告',
 service4Title: '境外商业合同起草、审阅',
 service4Subtitle: '中英文商业合同服务',
 service4Desc: '外向型企业在境外投资及贸易过程中，需要与合作方签订各种类型的商业合同，由于双方语言文化的差异以及各地法律不同，可能存在相应风险。LEVIY为客户量身定做不同的商业合同（中、英文），审阅合同，为客户争取合理的权益，避免一些不必要的损失。',
 service4Feature1Title: '合同起草服务',
 service4Feature1Item1: '商业合同起草（中文）',
 service4Feature1Item2: '商业合同起草（英文）',
 service4Feature1Item3: '各类商业合同定制',
 service4Feature1Item4: '符合当地法律要求',
 service4Feature1Item5: '保护客户合法权益',
 service4Feature2Title: '合同审阅服务',
 service4Feature2Item1: '合同审阅修改',
 service4Feature2Item2: '法律风险识别',
 service4Feature2Item3: '条款优化建议',
 service4Feature2Item4: '争取合理权益',
 service4Feature2Item5: '避免不必要损失',
 service5Title: '产权调查',
 service5Subtitle: '境外财产产权调查',
 service5Desc: '根据当事人要求LEVIY可对个人及商业组织的境外财产，包括财产所有人、产权登记、产权转移等情况进行调查。',
 service5Feature1Title: '个人财产调查',
 service5Feature1Item1: '境外个人财产调查',
 service5Feature1Item2: '财产所有人确认',
 service5Feature1Item3: '产权登记情况查询',
 service5Feature1Item4: '产权历史追溯',
 service5Feature2Title: '商业组织财产调查',
 service5Feature2Item1: '商业组织境外财产调查',
 service5Feature2Item2: '产权转移情况调查',
 service5Feature2Item3: '产权瑕疵分析',
 service5Feature2Item4: '财产权属证明',
 service6Title: '仲裁裁决境外执行',
 service6Subtitle: '境外仲裁与诉讼服务',
 service6Desc: '应案件的需求，LEVIY可为当事人启动仲裁或诉讼程序以及向被执行人或执行财产所在地相应机关申请执行等。',
 service6Feature1Title: '仲裁与诉讼',
 service6Feature1Item1: '启动仲裁程序',
 service6Feature1Item2: '启动诉讼程序',
 service6Feature1Item3: '仲裁和诉讼代理',
 service6Feature1Item4: '案件策略制定',
 service6Feature2Title: '执行服务',
 service6Feature2Item1: '向相应机关申请执行',
 service6Feature2Item2: '被执行人财产查找',
 service6Feature2Item3: '执行程序跟进',
 service6Feature2Item4: '执行方案设计',
 service7Title: '一般性法律服务',
 service7Subtitle: '全方位法律支持',
 service7Desc: '各种法律文件制作、律师函、律师参与谈判和见证；涉及公司法、证券法、投资法、银行法、移民和劳工法、环境法、海商海事法等法律服务。',
 service7Feature1Title: '法律文件服务',
 service7Feature1Item1: '各种法律文件制作',
 service7Feature1Item2: '律师函起草发送',
 service7Feature1Item3: '律师参与谈判',
 service7Feature1Item4: '法律见证服务',
 service7Feature1Item5: '法律文书翻译',
 service7Feature2Title: '专项法律服务',
 service7Feature2Item1: '公司法律服务',
 service7Feature2Item2: '证券法、投资法服务',
 service7Feature2Item3: '银行法律服务',
 service7Feature2Item4: '移民和劳工法服务',
 service7Feature2Item5: '环境法律服务',
 service7Feature2Item6: '海商海事法律服务',
}
